import React from "react";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";

const WalletSection = () => {
  return (
    <div>
      <div className="mb-5 border-b border-gray-200 pb-4">
        <h1 className="text-lg font-semibold text-gray-900">Wallet</h1>
        <p className="mt-1 text-sm text-gray-500">
          View wallet balance and transaction history.
        </p>
      </div>

      <div className="mb-5 rounded-lg border border-gray-200 p-4">
        <p className="text-sm font-medium text-gray-500">Total Balance</p>
        <div className="mt-2 flex items-end justify-between gap-4">
          <p className="text-3xl font-semibold text-gray-900">Rs 0.00</p>
          <button className="inline-flex items-center gap-2 rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white hover:bg-primary-700">
            <AddCardOutlinedIcon style={{ fontSize: 18 }} />
            Add Money
          </button>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200">
        <div className="border-b border-gray-200 px-4 py-3">
          <h2 className="text-sm font-semibold text-gray-900">
            Transaction History
          </h2>
        </div>
        <div className="flex flex-col items-center justify-center px-4 py-12 text-center">
          <AccountBalanceWalletOutlinedIcon
            className="text-gray-300"
            style={{ fontSize: 34 }}
          />
          <p className="mt-2 text-sm font-semibold text-gray-700">
            No transactions yet
          </p>
          <p className="mt-1 text-sm text-gray-500">
            Wallet activity will appear here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WalletSection;
